'use client';

import { Skeleton } from '@shared/components/shadcn';

function VerificationMethodSkeleton() {
  return (
    <div className="w-full py-3 px-4 rounded-lg bg-container-hover flex items-center justify-between gap-4" data-testid="verification-method-skeleton">
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <Skeleton className="w-10 h-10 rounded-full flex-shrink-0 bg-foreground/10" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-32 bg-foreground/10" />
          <Skeleton className="h-4 w-48 bg-foreground/10" />
        </div>
      </div>
      <Skeleton className="w-5 h-5 rounded flex-shrink-0 bg-foreground/10" />
    </div>
  );
}

export { VerificationMethodSkeleton };
